var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.width + 'px' }),attrs:{"id":"scene"}})
}
var staticRenderFns = []

export { render, staticRenderFns }